<template>
    <div id='LessonPreparationCenterPage'>
        <j-dict-select-tag :defaultShowAll="true" type="radioButton" @change="handleChangeType" v-model="courseType"
            :trigger-change="true" dictCode="course_type" />
        <a-row>
            <div class="data_box classBox">
                <div class="box_list" v-for="item,index in dataSource" :key="index" @click="toDetail(item)">
                    <img :src="item.courseCover_url" alt="">
                    <p class="box_text box_text1" style="">{{ item.courseName }}</p>
                </div>
            </div>

        </a-row>
    </div>
</template>
<script>
import classBox from './classBox';
import {getAction} from "@/api/manage"
export default {
    name: 'LessonPreparationCenterPage',
    components: { classBox },
    data() {
        return {
            formState: {},
            current: 1,
            totalNum: 20,
            courseType: '',
            dataSource: [],
            loading: true,
            courseType: "",
        }
    },
    computed: {},
    watch: {},
    methods: {
        getCourseList() {
            this.loading = true
            this.dataSource = []
            getAction("/teaching/teachingCourse/studentCourseNew", {
                courseType: this.courseType,
                pageSize: 999,
            }).then(res => {
                console.log(res);
                if (res.success) {
                    this.dataSource = res.result
                }
                this.loading = false
            })
        },
        toDetail(item) {
            this.$router.push({
                path: 'courseDetail',
                query: {
                    id: item.id,
                    departId: item.departId
                },
            })
        },
        handleChangeType(e) {
            this.courseType = e.target.value
            this.getCourseList()
        },
    },
    created() {this.getCourseList() },
    mounted() { },
}
</script>
<style lang='scss' scoped>
.ant-form-item {
    margin-bottom: 0 !important;
}

.data_box {
    width: 100%;
    height: auto;
    margin-bottom: 15px;
}
</style>